import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-679 (1.2 email + mint).
export const EmailScreen = () => (
  <StubScreen id="email" heading="Wie lautet Ihre E-Mail-Adresse?" />
);
